const DEFAULT_GOOGLE_SCOPE = 'openid email profile';

const normalizeInstitutionCode = (institutionCode = '') =>
	institutionCode.toString().trim().toUpperCase();

const getEnvBySuffix = (suffix) =>
	(process.env[`REACT_APP_${suffix}`] || '').toString().trim();

const removeNumericSuffix = (code = '') => code.replace(/_[0-9]+$/, '');

export const getGoogleCredentials = (institutionCode) => {
	const inputCode = normalizeInstitutionCode(institutionCode);
	const envInstitutionCode = normalizeInstitutionCode(
		process.env.REACT_APP_INSTITUTION_CODE || '',
	);

	const candidateCodes = Array.from(
		new Set([
			inputCode,
			removeNumericSuffix(inputCode),
			envInstitutionCode,
			removeNumericSuffix(envInstitutionCode),
		].filter(Boolean)),
	);

	const getFirstByCandidates = (prefix) => {
		for (const code of candidateCodes) {
			const value = getEnvBySuffix(`${prefix}_${code}_GOOGLE`);
			if (value) return value;
		}
		return '';
	};

	const clientId = getFirstByCandidates('CLIENTID');
	const redirectUri =
		getFirstByCandidates('REDIRECTURI') ||
		`${window.location.origin}/google-callback`;
	const scope = getFirstByCandidates('SCOPE') || DEFAULT_GOOGLE_SCOPE;

	return {
		client_id: clientId || null,
		redirect_uri: redirectUri,
		scope,
	};
};
